export default "__VITE_ASSET__wSaY4OIB__"